import { formatNumber } from '../../../utils/formatters';

const CustomLabel = (props) => {
  const { x, y, width, value } = props;

  if (!value || value === 0) return null;

  const formattedValue = formatNumber(value);
  const centerX = x + width / 2;
  const valueLength = String(formattedValue).length;
  const baseOffset = 15;
  const additionalOffset = Math.max(0, (valueLength - 2) * 4); // Дополнительный отступ для длинных чисел
  const labelY = y - (baseOffset + additionalOffset);

  return (
    <text
      x={centerX}
      y={labelY}
      fill="#4A5568"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="12"
      fontWeight="600"
      transform={`rotate(-90, ${centerX}, ${labelY})`}
    >
      {formattedValue}
    </text>
  );
};

export default CustomLabel;
